import {
  Component,
  Input,
} from '@angular/core';
import {
  AbstractControl,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
} from '@angular/forms';

@Component({
  selector: 'app-purpose-action-input',
  templateUrl: './purpose-action-input.component.html',
  styleUrls: ['./purpose-action-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: PurposeActionInputComponent,
    },
    {
      provide: NG_VALIDATORS,
      multi: true,
      useExisting: PurposeActionInputComponent,
    },
  ],
})
export class PurposeActionInputComponent {
  @Input()
  title = "Select Purpose Action...";

  @Input()
  isDisabled = false;


  @Input()
  actions = [
    'GOODS_RECEIVING',
    'GOODS_DISPATCHING',
    'CONTAINER_RECEIVING',
    'CONTAINER_DISPATCHING',
    'TRUCK_PARKING',
    'CONTAINER_TRANSACTION',
  ];

  public value?: string;
  public localValue?: string;

  constructor() {
  }

  ngOnInit(): void {
  }

  onChange = (val: string | undefined) => {
  };

  onTouched = () => { };

  touched = false;
  disabled = false;

  writeValue(val: string) {
    this.value = val;
    if (this.value != undefined || this.value != null) {
      this.localValue = this.value;
    }
  }

  onValueChange(val: string) {
    this.value = val;
    this.onChange(this.value);
this.writeValue(this.value);
  }

  registerOnChange(onChange: any) {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any) {
    this.onTouched = onTouched;
  }

  markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }

  validate(control: AbstractControl): ValidationErrors | null {
    return null;
  }
}
